import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProductsRemoved = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M38.85 9.15 24 3 9.15 9.15 3 24l6.15 14.85L24 45l14.85-6.15L45 24zm-24.6 12.6h19.5v4.5h-19.5z" })
});
export default SvgProductsRemoved;
